import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import AccessControl from '../AccessControl';

import SideNavItemLink from './SideNavItemLink';
import SideNavItemCollapsable from './SideNavItemCollapsable';

// Nav item can be a drawer with child or just a link
const SideNavItem = (props) => {
   const [level] = useState(props.level + 1);
   const [hasSubItems] = useState(props?.subItems?.length > 0);
   const [isActive, setIsActive] = useState(false);
   const location = useLocation();

   useEffect(() => {
      const pathnameSplitList = location.pathname.toLowerCase().split('/').filter((s) => (s));

      const isFound = props.activePathList.find((path) => {
         const pathSplitList = path.split('/').filter((s) => s);
         let isMatch = true;
         if (pathnameSplitList.length < pathSplitList.length) {
            isMatch = false;
         } else {
            for (let i = 0; i < pathSplitList.length; ++i) {
               if (pathSplitList[i] !== pathnameSplitList[i]) {
                  isMatch = false;
                  break;
               }
            }
         }
         return isMatch;
      });
      setIsActive(!!isFound);
   }, [location.pathname]);

   // DEPRECATING (AOE-backed) entries are gone — AOE was scaled to zero on
   // 2026-08-13 and their pages are login-walled for everyone, so the nav
   // (sidebar AND search results — both render through this component) hides
   // them too. Same gate as the wall in PageRouteList. Placed after the hooks
   // (rules of hooks).
   if (props.deprecating) {
      return null;
   }

   return (
      // name & path props is passed for debugging purposes ONLY
      <AccessControl access={props.access} path={props.path} name={props.name}>
         {
            hasSubItems
               ? (
                  <SideNavItemCollapsable
                     name={ props.name }
                     path={ props.path }
                     subItems={ props.subItems }
                     level={ level }
                     icon={props.icon}
                     parentDelta={props.parentDelta}
                     setParentDelta={props.setParentDelta}
                     isActive={isActive}
                     access={props.access}
                     deprecating={props.deprecating}
                     deprecatingText={props.deprecatingText}
                  />
               )
               : (
                  <SideNavItemLink
                     name={ props.name }
                     path={ props.path }
                     subItems={ props.subItems }
                     level={ level }
                     icon={props.icon}
                     deprecating={props.deprecating}
                     deprecatingText={props.deprecatingText}
                     ported={props.ported}
                     isActive={isActive}
                     isComingSoon={props.isComingSoon}
                  />
               )
         }
      </AccessControl>
   );
};

SideNavItem.propTypes = {
   deprecating: PropTypes.bool,
   deprecatingText: PropTypes.string,
   ported: PropTypes.bool,
   name: PropTypes.string.isRequired,
   path: PropTypes.oneOfType([PropTypes.string]),
   setParentDelta: PropTypes.func.isRequired,
   level: PropTypes.number,
   icon: PropTypes.elementType,
   parentDelta: PropTypes.any,
   subItems: PropTypes.arrayOf(PropTypes.object),
   field: PropTypes.string,
   rolesVisibleTo: PropTypes.shape({
      employer: PropTypes.arrayOf(PropTypes.string),
      partner: PropTypes.arrayOf(PropTypes.string),
   }),
   isComingSoon: PropTypes.bool,
   pathMatcherMap: PropTypes.shape({}),
   activePathList: PropTypes.arrayOf(PropTypes.string).isRequired,
};

SideNavItem.defaultProps = {
   ported: false,
   path: undefined,
   level: undefined,
   subItems: [],
   field: undefined,
   icon: undefined,
   rolesVisibleTo: {
      employer: [],
      partner: [],
   },
   isComingSoon: false,
   pathMatcherMap: {},
   parentDelta: undefined,
};

export default SideNavItem;
